export const formatVolume = (volume: string) => volume.replace(/(\.\d[1-9]*)0+$/, '$1');
